module.exports = __webpack_public_path__ + "static/media/Location_Book-Page13.a61f3836.png";